/** @format */

import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";

const Header = () => {
	return (
		<>
			{/* Navbar */}
			<Navbar className="custom-navbar" expand="lg">
				<Container>
					<Navbar.Brand href="#home" className="navbar-brand">
						<img
							src={"/logo.png"}
							alt="HealthyLife Clinic Logo"
							className="navbar-logo"
						/>
						<span className="navbar-text fw-bold d-none d-md-block">
							SRI RAJARAJESHWARA CLINICS
						</span>{" "}
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav">
						<Nav className="ms-auto">
							<Nav.Link href="#home" className="custom-nav-link">
								HOME
							</Nav.Link>
							<Nav.Link href="#doctors" className="custom-nav-link">
								DOCTOR
							</Nav.Link>
							<Nav.Link href="#gallery" className="custom-nav-link">
								GALLERY
							</Nav.Link>
							<Nav.Link href="#contact" className="custom-nav-link">
								CONTACT US
							</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>

			{/* Jumbotron */}
			<div className="custom-jumbotron" id="home">
				<div className="jumbotron-text">
					<h1 className="display-4">
						Welcome to <br />
						<span>SRI RAJARAJESHWARA CLINICS</span>
					</h1>
					<p className="lead">
						At our clinic, your health and happiness come first. Our experienced
						team is dedicated to providing exceptional care tailored to your
						unique needs, ensuring a comfortable and supportive experience on
						your journey to better health.
					</p>
					<a
						href="https://wa.me/8686101203?text=Hello%2C%20I%20would%20like%20to%20book%20an%20appointment"
						target="_blank"
						rel="noopener noreferrer">
						<Button variant="light" size="lg" className="custom-button">
							<strong>Book Appointment</strong>
						</Button>
					</a>
				</div>
			</div>
		</>
	);
};

export default Header;
